import { render, staticRenderFns } from "./assignmentPanel.vue?vue&type=template&id=df484230&scoped=true&"
import script from "./assignmentPanel.vue?vue&type=script&lang=js&"
export * from "./assignmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./assignmentPanel.vue?vue&type=style&index=0&id=df484230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df484230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df484230')) {
      api.createRecord('df484230', component.options)
    } else {
      api.reload('df484230', component.options)
    }
    module.hot.accept("./assignmentPanel.vue?vue&type=template&id=df484230&scoped=true&", function () {
      api.rerender('df484230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/assignmentPanel.vue"
export default component.exports